import { Controller } from "@hotwired/stimulus"
import interact from "interactjs";

// Connects to data-controller="side-page"
export default class extends Controller {
  connect() {
    const self = this
    this.pageContent = document.querySelector('#page-content > div')
    this.pageContentEl = document.getElementById('page-content')
    this.sideWrapper = document.getElementById('side_page_wrapper')
    this.sideWrapper.scrollTop = 0;
    const computedStyle = window.getComputedStyle(this.sideWrapper );
    if (computedStyle.marginRight === '0px') {
      return;
    }
    // standaloneのtask_browse_paneが開いていればその幅分オフセット
    const standalonePaneWrapper = document.getElementById('task_browse_pane_wrapper')
    const standalonePaneContainer = standalonePaneWrapper?.querySelector('#task_browse_pane_container')
    const paneOffset = (standalonePaneWrapper?.classList.contains('task-browse-pane-open') && standalonePaneContainer)
      ? standalonePaneContainer.offsetWidth : 0
    this.sideWrapper.setAttribute('style', `margin-right: 0; right: ${paneOffset}px`)
    this.sideWrapper.classList.add('shadow', 'active')
    if (this.pageContent.classList.contains('container')) {
      this.pageContent.setAttribute('style', 'margin-left: 0 !important')
    }

    // ボード画面（PC）の場合のみ、サイドページの幅分padding-rightを設定
    this.isBoardPage = !!(document.getElementById('progress_board') || document.getElementById('assignment_board'))
    this.shouldApplyPadding = this.isBoardPage && window.innerWidth >= 992
    if (this.shouldApplyPadding) {
      this.#updatePageContentPadding()
    }

    // リサイズ
    interact('#side_page_wrapper')
        .resizable({
          edges: { left: true, right: false, bottom: false, top: false },
          listeners: {
            move (event) {
              event.target.setAttribute('style', `width: ${event.rect.width}px; margin-right: 0; right: ${paneOffset}px;`)
              // リサイズ時もpadding-rightを更新（ボード画面のみ）
              if (self.shouldApplyPadding) {
                self.pageContentEl.style.paddingRight = `${event.rect.width}px`
              }
            }
          },
          modifiers: [
            interact.modifiers.restrictSize({
              min: { width: 500 },
            }),
          ]
        })

    // 閉じる
    this.#clickOutside()
  }

  dismiss(event) {
    event?.preventDefault();
    // 関連タスクペインが開いている場合はクラスを削除
    this.sideWrapper.classList.remove('task-browse-pane-open')
    // 現在の幅に基づいてマージンを計算
    const currentWidth = this.sideWrapper.offsetWidth
    this.sideWrapper.setAttribute('style', `margin-right: -${currentWidth + 100}px`)
    this.sideWrapper.classList.remove('shadow', 'active')
    if (this.pageContent.classList.contains('container')) {
      this.pageContent.setAttribute('style', '')
    }
    // padding-rightをリセット（ボード画面のみ）
    if (this.isBoardPage) {
      this.pageContentEl.style.paddingRight = ''
    }
  }

  remove(event) {
    if (confirm('削除します')) {
      this.dismiss();
    } else {
      event.preventDefault();
    }
  }

  disconnect() {
  }

  #updatePageContentPadding() {
    // サイドページが表示されたら、その幅分のpadding-rightを設定して
    // 呼び出し元コンテンツがスクロールで全て見えるようにする
    const sidePageWidth = this.sideWrapper.offsetWidth
    this.pageContentEl.style.paddingRight = `${sidePageWidth}px`
  }

  #clickOutside() {
    const self = this;
    let isDragging = false;
    let startX = 0;
    let startY = 0;
    const DRAG_THRESHOLD = 5; // 5ピクセル以上動いたらドラッグと判定

    const mousedownHandler = function (event) {
      isDragging = false;
      startX = event.clientX;
      startY = event.clientY;
    };

    const mousemoveHandler = function (event) {
      if (!isDragging) {
        const deltaX = Math.abs(event.clientX - startX);
        const deltaY = Math.abs(event.clientY - startY);
        if (deltaX > DRAG_THRESHOLD || deltaY > DRAG_THRESHOLD) {
          isDragging = true;
        }
      }
    };

    const mouseupHandler = function (event) {
      if (!isDragging) {
        handleClick(event);
      }
      isDragging = false;
    };

    document.addEventListener('mousedown', mousedownHandler);
    document.addEventListener('mousemove', mousemoveHandler);
    document.addEventListener('mouseup', mouseupHandler);

    function handleClick(event) {
      const isLink = event.target.tagName === 'A';
      const isModal = event.target.closest('.modal');
      const isFloatMenu = event.target.closest('div[data-float-menu-target="menu"]');
      const isHandler = event.target.closest('.task_handler');
      const isBrowsePane = event.target.closest('#task_browse_pane_container');
      if (!self.sideWrapper.contains(event.target) && !isLink && !isModal && !isFloatMenu && !isHandler && !isBrowsePane) {
        // イベントリスナーの削除
        document.removeEventListener('mousedown', mousedownHandler);
        document.removeEventListener('mousemove', mousemoveHandler);
        document.removeEventListener('mouseup', mouseupHandler);

        self.dismiss(event);
      }
    }
  }
}